var React = require('react');

function YCombinator (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z"}));
}

YCombinator.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = YCombinator;

YCombinator.default = YCombinator;
